import { createFileRoute } from "@tanstack/react-router";
import { listFeatureFlags } from "api-client";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminFeatureFlagsPage } from "src/pages/AdminFeatureFlagsPage";

import { FEATURE_FLAGS_DEFAULT_PAGE_SIZE } from "./route";

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_admin/admin/feature-flags/")({
  component: AdminFeatureFlagsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: (args) => {
    return args.search;
  },
  async loader(args) {
    return await loaderHandler(async () => {
      const deps = args.deps;
      const page = deps.p ?? 0;
      const pageSize = deps.ps ?? FEATURE_FLAGS_DEFAULT_PAGE_SIZE;

      const featureFlags = await listFeatureFlags({
        query: {
          query: deps.q,
          pageIndex: page,
          pageSize: pageSize,
        },
      }).then((response) => {
        return response.data.data;
      });

      return {
        data: {
          featureFlags: featureFlags.currentPage,
          pageInfo: featureFlags.pageInfo,
          pageSize: pageSize,
        },
      };
    });
  },
});
